// Shared helper — updates the cart icon bubble
function updateCartBubble(itemCount) {
  const bubble = document.querySelector('#cart-icon-bubble .cart-count-bubble');
  const countEl = bubble && bubble.querySelector('span[aria-hidden]');
  const labelEl = bubble && bubble.querySelector('span.visually-hidden');

  if (itemCount > 0 && bubble) {
    countEl.textContent = itemCount;
    labelEl.textContent = `${itemCount} item${itemCount === 1 ? '' : 's'}`;
  } else if (itemCount === 0 && bubble) {
    bubble.remove();
  }
}

function addToCartAjax(variantId, quantity = 1) {
  return fetch(theme.routes.cart_add_url + '.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity })
  })
    .then((response) => response.json())
    .then((data) => {
      if (data.status === 422) {
        document.dispatchEvent(new CustomEvent('ajaxProduct:error', {
          detail: { errorMessage: data.description }
        }));
      } else {
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
          detail: { product: data }
        }));
        showCartNotification(data);
        fetch(`${theme.routes.cart_url}.js`)
          .then((r) => r.json())
          .then((cart) => updateCartBubble(cart.item_count));
      }
    })
    .catch((err) => console.error(err));
}

// PDP form fix
document.addEventListener('DOMContentLoaded', () => {
  const form = document.querySelector('form[data-type="add-to-cart-form"]');
  if (!form) return;

  form.addEventListener('submit', (e) => {
    e.preventDefault();
    const formData = new FormData(form);
    const variantId = formData.get('id');
    const submitBtn = form.querySelector('[type="submit"]');
    submitBtn.setAttribute('disabled', true);
    submitBtn.classList.add('loading');

    addToCartAjax(variantId).finally(() => {
      submitBtn.removeAttribute('disabled');
      submitBtn.classList.remove('loading');
    });
  });
});

// Boost interception — capture phase, before Boost's own handler
document.addEventListener('click', (e) => {
  const boostBtn = e.target.closest('.boost-sd__button--select-option');
  if (!boostBtn) return;

  const metadata = boostBtn.getAttribute('data-metadata');
  if (!metadata) return;

  let parsed;
  try {
    parsed = JSON.parse(metadata);
  } catch {
    return;
  }

  const addToCartAction = parsed?.action?.addToCart;
  if (!addToCartAction) return; // let quickView / other actions pass through untouched

  e.preventDefault();
  e.stopImmediatePropagation(); // blocks Boost's own bubble-phase handler

  boostBtn.setAttribute('disabled', true);
  boostBtn.classList.add('loading');

  addToCartAjax(addToCartAction.productId).finally(() => {
    boostBtn.removeAttribute('disabled');
    boostBtn.classList.remove('loading');
  });
}, true); // capture: true — runs before Boost's bubble-phase listener

function showCartNotification(item) {
  const notif = document.getElementById('simple-cart-notification');
  if (!notif) return;

  const img = notif.querySelector('.simple-cart-notification__image');
  const title = notif.querySelector('.simple-cart-notification__title');

  if (item.image) {
    img.src = item.image;
    img.alt = ''; // decorative; title text already conveys the info
    img.hidden = false;
  } else {
    img.hidden = true;
  }
  title.textContent = item.product_title || item.title || '';

  notif.hidden = false;
  requestAnimationFrame(() => notif.classList.add('is-visible'));

  clearTimeout(notif._hideTimeout);
  // Pause dismissal on hover/focus so users have time to read or act
  notif._hideTimeout = setTimeout(() => hideCartNotification(), 6000);
}

function hideCartNotification() {
  const notif = document.getElementById('simple-cart-notification');
  if (!notif) return;
  notif.classList.remove('is-visible');
  setTimeout(() => { notif.hidden = true; }, 300);
}

document.addEventListener('DOMContentLoaded', () => {
  const notif = document.getElementById('simple-cart-notification');
  const closeBtn = document.querySelector('.simple-cart-notification__close');

  if (closeBtn) closeBtn.addEventListener('click', hideCartNotification);

  if (notif) {
    // Pause auto-dismiss while hovered or focused inside
    notif.addEventListener('mouseenter', () => clearTimeout(notif._hideTimeout));
    notif.addEventListener('focusin', () => clearTimeout(notif._hideTimeout));
    notif.addEventListener('mouseleave', () => {
      notif._hideTimeout = setTimeout(() => hideCartNotification(), 3000);
    });
  }
});


(function () {
  console.log('[carousel-fix] script loaded');

  function syncFocusability(container) {
    const hiddenContainers = container.querySelectorAll('[aria-hidden]');
    let changedCount = 0;

    hiddenContainers.forEach((el) => {
      const isHidden = el.getAttribute('aria-hidden') === 'true';
      const focusables = el.querySelectorAll('a, button, input, select, textarea, [tabindex]');
      focusables.forEach((focusable) => {
        if (isHidden) {
          if (focusable.getAttribute('tabindex') !== '-1') {
            if (!focusable.hasAttribute('data-original-tabindex')) {
              focusable.setAttribute(
                'data-original-tabindex',
                focusable.getAttribute('tabindex') || ''
              );
            }
            focusable.setAttribute('tabindex', '-1');
            changedCount++;
          }
        } else if (focusable.hasAttribute('data-original-tabindex')) {
          const original = focusable.getAttribute('data-original-tabindex');
          if (original) {
            focusable.setAttribute('tabindex', original);
          } else {
            focusable.removeAttribute('tabindex');
          }
          focusable.removeAttribute('data-original-tabindex');
          changedCount++;
        }
      });
    });

    console.log(`[carousel-fix] sync ran — ${hiddenContainers.length} hidden containers checked, ${changedCount} tabindex changes made`);
  }

  function runSync() {
    syncFocusability(document.body);
  }

  document.addEventListener('DOMContentLoaded', () => {
    console.log('[carousel-fix] DOMContentLoaded fired');
    runSync();
  });

  window.addEventListener('load', () => {
    console.log('[carousel-fix] window load fired');
    runSync();
    setTimeout(runSync, 500);
    setTimeout(runSync, 1500);
  });

  const observer = new MutationObserver((mutations) => {
    let shouldSync = false;
    mutations.forEach((mutation) => {
      if (mutation.type === 'attributes' && mutation.attributeName === 'aria-hidden') {
        shouldSync = true;
      }
      if (mutation.type === 'childList' && (mutation.addedNodes.length || mutation.removedNodes.length)) {
        shouldSync = true;
      }
    });
    if (shouldSync) {
      console.log('[carousel-fix] MutationObserver triggered a sync');
      runSync();
    }
  });

  observer.observe(document.body, {
    attributes: true,
    attributeFilter: ['aria-hidden'],
    childList: true,
    subtree: true
  });
  setInterval(runSync, 300);
window.__syncFocusability = runSync;
})();